import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      icon: 'home',
      navigationDrawer: true,
      component: () => import('@/views/Home.vue'),
    },
    {
      path: '/users',
      name: 'Users',
      icon: 'person',
      navigationDrawer: true,
      component: () => import('@/views/Users.vue'),
    },
    {
      path: '/users/add',
      name: 'Add User',
      icon: 'person',
      navigationDrawer: false,
      component: () => import('@/views/users/Add.vue'),
    },
    {
      path: '/users/edit/:id',
      name: 'Edit User',
      icon: 'person',
      navigationDrawer: false,
      component: () => import('@/views/users/Edit.vue'),
    },
    {
      path: '/users/show/:id',
      name: 'Show User',
      icon: 'person',
      navigationDrawer: false,
      component: () => import('@/views/users/Show.vue'),
    },
    {
      path: '/sprints',
      name: 'Sprints',
      icon: 'arrow_right_alt',
      navigationDrawer: true,
      component: () => import('@/views/Sprints.vue'),
    },
    {
      path: '/sprints/add',
      name: 'Add Sprint',
      icon: 'arrow_right_alt',
      navigationDrawer: false,
      component: () => import('@/views/sprints/Add.vue'),
    },
    {
      path: '/sprints/edit/:id',
      name: 'Edit Sprint',
      icon: 'arrow_right_alt',
      navigationDrawer: false,
      component: () => import('@/views/sprints/Edit.vue'),
    },
    {
      path: '/sprints/show/:id',
      name: 'Show Sprint',
      icon: 'arrow_right_alt',
      navigationDrawer: false,
      component: () => import('@/views/sprints/Show.vue'),
    },
    {
      path: '/stories',
      name: 'Stories',
      icon: 'book',
      navigationDrawer: true,
      component: () => import('@/views/Stories.vue'),
    },
    {
      path: '/stories/add',
      name: 'Add Story',
      icon: 'book',
      navigationDrawer: false,
      component: () => import('@/views/stories/Add.vue'),
    },
    {
      path: '/stories/edit/:id',
      name: 'Edit Story',
      icon: 'book',
      navigationDrawer: false,
      component: () => import('@/views/stories/Edit.vue'),
    },
    {
      path: '/stories/show/:id',
      name: 'Show Story',
      icon: 'book',
      navigationDrawer: false,
      component: () => import('@/views/stories/Show.vue'),
    },
    {
      path: '/stories-archive',
      name: 'Stories Archive',
      icon: 'archive',
      navigationDrawer: true,
      component: () => import('@/views/StoriesArchive.vue'),
    },
  ],
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
